function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
import {
    Slider,
    Picker
} from './components/components';
var VideoColor = function () {
    function VideoColor(player) {
        var _this = this;
        _classCallCheck(this, VideoColor);
        this.player = player;
        this.video = player.video;
        this.filter = this.player.options.videoColor;
        this.initBrightness();
        this.initSaturate();
        this.initContrast();
        this.initHueRotate();
        this.player.template.video_color_reset_btn.addEventListener('click', function (e) {
            e.stopPropagation();
            _this.reset();
        });
    }
    _createClass(VideoColor, [
        {
            key: 'initBrightness',
            value: function initBrightness() {
                var _this2 = this;
                this.brightnessSlider = new Slider(this.player.template.video_brightness_slider, 0, 250, 1, this.filter.brightness * 100, {
                    start: function start() {
                    },
                    update: function update(value, flag) {
                    },
                    change: function change(value) {
                        var _this2$filter = _this2.filter, saturate = _this2$filter.saturate, contrast = _this2$filter.contrast, hueRotate = _this2$filter.hueRotate;
                        _this2.filter.brightness = value / 100;
                        _this2.player.template.video_brightness_value.innerText = value + '%';
                        _this2.player.video.style.filter = 'brightness('.concat(value / 100, ') contrast(').concat(contrast, ') saturate(').concat(saturate, ') hue-rotate(').concat(hueRotate, 'deg)');
                    },
                    end: function end(value) {
                        _this2.player.events.trigger('setPlayer', {
                            key: 'videoColor',
                            value: { brightness: value / 100 }
                        });
                    }
                }, this.player.template.setMask);
            }
        },
        {
            key: 'initSaturate',
            value: function initSaturate() {
                var _this3 = this;
                this.saturateSlider = new Slider(this.player.template.video_saturate_slider, 0, 250, 1, this.filter.saturate * 100, {
                    start: function start() {
                    },
                    update: function update(value, flag) {
                    },
                    change: function change(value) {
                        var _this3$filter = _this3.filter, brightness = _this3$filter.brightness, contrast = _this3$filter.contrast, hueRotate = _this3$filter.hueRotate;
                        _this3.filter.saturate = value / 100;
                        _this3.player.template.video_saturate_value.innerText = value + '%';
                        _this3.player.video.style.filter = 'brightness('.concat(brightness, ') contrast(').concat(contrast, ') saturate(').concat(value / 100, ') hue-rotate(').concat(hueRotate, 'deg)');
                    },
                    end: function end(value) {
                        _this3.player.events.trigger('setPlayer', {
                            key: 'videoColor',
                            value: { saturate: value / 100 }
                        });
                    }
                }, this.player.template.setMask);
            }
        },
        {
            key: 'initContrast',
            value: function initContrast() {
                var _this4 = this;
                this.contrastSlider = new Slider(this.player.template.video_contrast_slider, 0, 250, 1, this.filter.contrast * 100, {
                    start: function start() {
                    },
                    update: function update(value, flag) {
                    },
                    change: function change(value) {
                        var _this4$filter = _this4.filter, brightness = _this4$filter.brightness, saturate = _this4$filter.saturate, hueRotate = _this4$filter.hueRotate;
                        _this4.filter.contrast = value / 100;
                        _this4.player.template.video_contrast_value.innerText = value + '%';
                        _this4.player.video.style.filter = 'brightness('.concat(brightness, ') contrast(').concat(value / 100, ') saturate(').concat(saturate, ') hue-rotate(').concat(hueRotate, 'deg)');
                    },
                    end: function end(value) {
                        _this4.player.events.trigger('setPlayer', {
                            key: 'videoColor',
                            value: { contrast: value / 100 }
                        });
                    }
                }, this.player.template.setMask);
            }
        },
        {
            key: 'initHueRotate',
            value: function initHueRotate() {
                var _this5 = this;
                this.hueRotateSlider = new Slider(this.player.template.video_hue_rotate_slider, 0, 360, 90, this.filter.hueRotate * 360, {
                    start: function start() {
                    },
                    update: function update(value, flag) {
                    },
                    change: function change(value) {
                        var _this5$filter = _this5.filter, brightness = _this5$filter.brightness, saturate = _this5$filter.saturate, contrast = _this5$filter.contrast;
                        _this5.filter.hueRotate = value;
                        _this5.player.template.video_hue_rotate_value.innerText = value + 'deg';
                        _this5.player.video.style.filter = 'brightness('.concat(brightness, ') contrast(').concat(contrast, ') saturate(').concat(saturate, ') hue-rotate(').concat(value, 'deg)');
                    },
                    end: function end(value) {
                        _this5.player.events.trigger('setPlayer', {
                            key: 'videoColor',
                            value: { hueRotate: value / 100 }
                        });
                    }
                }, this.player.template.setMask);
            }
        },
        {
            key: 'reset',
            value: function reset() {
                this.saturateSlider.update(100);
                this.brightnessSlider.update(100);
                this.contrastSlider.update(100);
                this.hueRotateSlider.update(0);
                this.player.events.trigger('setPlayer', {
                    key: 'videoColor',
                    value: {
                        brightness: 1,
                        contrast: 1,
                        saturate: 1,
                        hueRotate: 0
                    }
                });
            }
        },
        {
            key: 'show',
            value: function show() {
                this.player.template.video_color_mask.classList.add('show');
            }
        },
        {
            key: 'hide',
            value: function hide() {
                this.player.template.video_color_mask.classList.remove('show');
            }
        },
        {
            key: 'toggle',
            value: function toggle() {
                if (this.player.template.video_color_mask.classList.contains('show'))
                    this.hide();
                else
                    this.show();
            }
        }
    ]);
    return VideoColor;
}();
export {
    VideoColor as default
};